﻿module Client.ContractPage.CostOfConstruction.Utils

open System
open Client
open Fable.Core
open Fable.React
open Fable.React.Props
open Feliz
open Model
open FSharpPlus
open PortalLibs.Shared
open Shared

let alignRight = [ TextAlign TextAlignOptions.Right ]
let formatPossibleNotFinite x = if JS.isFinite x then sprintf "%s%%" (x.ToString()) else String.Empty 
let formatMargin profit revenue =
  (profit / revenue) * 100.0
  |> fun x -> Math.Round(x, 1)
  |> formatPossibleNotFinite
  |> str
  
let optionalRedColor x = [if JS.isFinite x && x < 0.0 then yield style.color.red]

type Costs =
  { OrigEstCost: float
    CurrentEstCost: float
    ActualCostToDate: float
    ActualHoursToDate: float
    CostToComplete: float
    PctEstimate: float
    PMRevisedCost: float
    EarnedRevenue: float
    GrossProfit: float }
  static member (+) (a: Costs, b: Costs) =
    { OrigEstCost = a.OrigEstCost + b.OrigEstCost
      CurrentEstCost = a.CurrentEstCost + b.CurrentEstCost
      ActualCostToDate = a.ActualCostToDate + b.ActualCostToDate
      ActualHoursToDate = a.ActualHoursToDate + b.ActualHoursToDate
      CostToComplete = a.CostToComplete + b.CostToComplete
      PctEstimate = a.PctEstimate + b.PctEstimate
      PMRevisedCost = a.PMRevisedCost + b.PMRevisedCost
      EarnedRevenue = a.EarnedRevenue + b.EarnedRevenue
      GrossProfit = a.GrossProfit + b.GrossProfit }
  static member Zero =
    { OrigEstCost = 0.0
      CurrentEstCost = 0.0
      ActualCostToDate = 0.0
      ActualHoursToDate = 0.0
      CostToComplete = 0.0
      PctEstimate = 0.0
      PMRevisedCost = 0.0
      EarnedRevenue = 0.0
      GrossProfit = 0.0 }
    
  static member FromJobCost(jobCost: JobCost) =
    { OrigEstCost = jobCost.OrigEstCost
      CurrentEstCost = jobCost.CurrentEstCost
      ActualCostToDate = jobCost.ActualCostToDate
      ActualHoursToDate = jobCost.ActualHoursToDate
      CostToComplete = jobCost.CostToComplete
      PctEstimate = jobCost.PctEstimate
      PMRevisedCost = jobCost.PMRevisedCost
      EarnedRevenue = jobCost.EarnedRevenue
      GrossProfit = jobCost.GrossProfit }

let totalColumns contractSettings costs =
  let tdPrice x =
    Html.td [
      prop.style [style.textAlign.right]
      prop.children [
        Html.strong [
          prop.style <| optionalRedColor x
          prop.text(x |> DisplayNumber.AsCurrency.std)
        ]
      ]
    ]
  
  let total = costs |> Seq.map Costs.FromJobCost |> sum
  
  [ tdPrice total.EarnedRevenue
    tdPrice total.OrigEstCost 
    tdPrice total.CurrentEstCost
    tdPrice total.ActualCostToDate
    tdPrice total.CostToComplete
    tdPrice total.GrossProfit
    td [ Style alignRight ] [
          strong [] [ formatMargin total.GrossProfit total.EarnedRevenue ] 
        ]
    if contractSettings.Projections then
      td [ Style alignRight ] []

      td [ Style alignRight ] [
        strong [ Style [
                   if total.ActualCostToDate > total.PMRevisedCost then
                     yield Color "red"
                 ] ] [
          total.PMRevisedCost |> DisplayNumber.AsCurrency.stdStr
        ]
      ] ]